module.exports = {
    sanity: {
      projectId: process.env.GATSBY_SANITY_PROJECT_ID || "0k3yyj1l",
      dataset: process.env.GATSBY_SANITY_DATASET || "production",
    }
  };
  